import { SetAuth } from '~utils/auth';

export const LoginRedirect = (app, navigation) => {
	app.setAuth({});
	SetAuth(null);
	navigation.navigate('Login');
};